/*
 * sniarti-contact.js — CEC-494 contact form behaviour. Shared cross-brand
 * layer: copy verbatim across brands alongside sections/contact.liquid and the
 * CEC-494 block in sniarti-base.css.
 *
 * The inquiry-type dropdown drives three things. Which panel shows (send button
 * vs. the defect e-mail route) is pure CSS — `:has(option[data-kind]:checked)`
 * in sniarti-base.css — so it is right on first paint and survives this file
 * failing to load. What is left here is what CSS cannot express:
 *
 *   1. `required` on the order number, for the types that need one. The Liquid
 *      never marks it required, so with JS off the form is still submittable —
 *      degrade toward accepting the message, never toward blocking it.
 *   2. `disabled` on the submit button while the defect type is selected.
 *      Hiding it in CSS is not enough: a display:none submit button still
 *      answers the Enter key (implicit submission), which would push a defect
 *      report down the form path with no photo attached.
 *   3. The pre-filled mail body, built from what the customer has already typed
 *      so the photo is the only thing left for them to attach.
 *
 * Field labels are read out of the DOM rather than hard-coded, so the body
 * follows the storefront language and any wording the merchant edits.
 */
(function () {
  // Matches the hard-coded `name` attributes in sections/contact.liquid. These
  // are the field names in the contact notification e-mail; support filters on
  // them, so they are fixed, not derived from the (translatable) labels.
  var ORDER_NUMBER_NAME = 'contact[注文番号]';

  // mailto: length limits vary by client and long URLs are silently truncated
  // (or dropped) rather than erroring, so cap the body well short of trouble.
  var MAX_BODY_LENGTH = 1800;

  function inquiryTypeSelect(form) {
    var selects = form.querySelectorAll('select');

    // Not `form.querySelector('select')`: merchants can add their own dropdown
    // fields as section blocks, and those may come first in the DOM.
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].querySelector('option[data-kind]')) return selects[i];
    }

    return null;
  }

  function selectedOption(select) {
    return select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
  }

  function labelFor(form, field) {
    var label = field.id ? form.querySelector('label[for="' + field.id + '"]') : null;
    var text = label ? label.textContent : '';

    // Fields render their label as a placeholder too; either is a fine caption.
    return (text || field.getAttribute('placeholder') || '').trim();
  }

  function mailBody(form, note) {
    var fields = form.querySelectorAll('.input, .textarea, .select');
    var lines = [];

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.type === 'hidden' || field.disabled) continue;

      var label = labelFor(form, field);
      if (!label) continue;

      lines.push(label + '：' + (field.value || '').trim());
    }

    if (note) lines.push('', note);

    var body = lines.join('\n');
    return body.length > MAX_BODY_LENGTH ? body.slice(0, MAX_BODY_LENGTH) : body;
  }

  function refreshMailto(form, panel) {
    var link = panel.querySelector('a[href^="mailto:"]');
    var address = panel.getAttribute('data-mail-to');
    if (!link || !address) return;

    var href = 'mailto:' + address;
    var query = [];

    var subject = panel.getAttribute('data-mail-subject');
    if (subject) query.push('subject=' + encodeURIComponent(subject));
    query.push('body=' + encodeURIComponent(mailBody(form, panel.getAttribute('data-mail-note'))));

    link.href = href + '?' + query.join('&');
  }

  function init(form) {
    var select = inquiryTypeSelect(form);
    if (!select) return;

    var orderNumber = form.querySelector('[name="' + ORDER_NUMBER_NAME + '"]');
    var submit = form.querySelector('button[type="submit"]');
    var panel = form.querySelector('[data-contact-defect]');

    function apply() {
      var option = selectedOption(select);
      var kind = option ? option.getAttribute('data-kind') : null;

      if (orderNumber) {
        orderNumber.required = !!(option && option.hasAttribute('data-requires-order-number'));
      }

      if (submit) submit.disabled = kind === 'defect';
      if (panel && kind === 'defect') refreshMailto(form, panel);
    }

    select.addEventListener('change', apply);

    // Keep the mail body in step with the form while the defect panel is open;
    // reading the values at click time alone would miss browser autofill.
    if (panel) {
      form.addEventListener('input', function () {
        var option = selectedOption(select);
        if (option && option.getAttribute('data-kind') === 'defect') refreshMailto(form, panel);
      });
    }

    apply();
  }

  function start() {
    var forms = document.querySelectorAll('.contact-form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The theme editor re-renders a section in place, which drops these listeners.
  document.addEventListener('shopify:section:load', function (event) {
    var forms = event.target.querySelectorAll('.contact-form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  });
})();
